import { useId } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AZFlag = ({ sx, ...props }: SvgIconProps) => {
  const clipId = useId();

  return (
    <SvgIcon
      viewBox='0 0 25 25'
      fill='none'
      sx={{ width: '24px', height: '24px', fill: 'none', ...sx }}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path d='M36.5 0.5H-11.5V24.5H36.5V0.5Z' fill='#509E2F' />
        <path d='M36.5 0.5H-11.5V16.5H36.5V0.5Z' fill='#EF3340' />
        <path d='M36.5 0.5H-11.5V8.5H36.5V0.5Z' fill='#00B5E2' />
        <path
          d='M11.2998 16.1C13.288 16.1 14.8998 14.4882 14.8998 12.5C14.8998 10.5117 13.288 8.89996 11.2998 8.89996C9.3116 8.89996 7.69982 10.5117 7.69982 12.5C7.69982 14.4882 9.3116 16.1 11.2998 16.1Z'
          fill='white'
        />
        <path
          d='M12.0998 15.5C13.7566 15.5 15.0998 14.1569 15.0998 12.5C15.0998 10.8431 13.7566 9.5 12.0998 9.5C10.4429 9.5 9.09976 10.8431 9.09976 12.5C9.09976 14.1569 10.4429 15.5 12.0998 15.5Z'
          fill='#EF3340'
        />
        <path
          d='M15.3 10.5001L15.6827 11.5762L16.7142 11.0859L16.2239 12.1174L17.3 12.5001L16.2239 12.8827L16.7142 13.9143L15.6827 13.4239L15.3 14.5001L14.9173 13.4239L13.8858 13.9143L14.3762 12.8827L13.3 12.5001L14.3762 12.1174L13.8858 11.0859L14.9173 11.5762L15.3 10.5001Z'
          fill='white'
        />
      </g>
      <path
        d='M12.5 0.25C19.2655 0.25 24.75 5.73451 24.75 12.5C24.75 19.2655 19.2655 24.75 12.5 24.75C5.73451 24.75 0.25 19.2655 0.25 12.5C0.25 5.73451 5.73451 0.25 12.5 0.25Z'
        fill='none'
        stroke='#DFE1E1'
        strokeWidth='0.5'
      />
      <defs>
        <clipPath id={clipId}>
          <path
            d='M0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default AZFlag;
